import {
  ORGANIZATION_SETTINGS_PEOPLE_INFO_FIELDS,
  USER_BASIC_PERSONAL_INFORMATION,
  USER_EMPLOYMENT_INFORMATION,
} from '../../../constants/people';
import { FIELD_TYPES } from '../../../constants/fieldTypes';

export const USER_FIELD_CATEGORY_KEYS = {
  PERSONAL: 'personal',
  EMPLOYMENT: 'employment',
};

export const USER_FIELD_CATEGORIES = [
  {
    key: USER_FIELD_CATEGORY_KEYS.PERSONAL,
    translationKey: 'personalInformation',
    fieldKeys: Object.values(USER_BASIC_PERSONAL_INFORMATION),
  },
  {
    key: USER_FIELD_CATEGORY_KEYS.EMPLOYMENT,
    translationKey: 'employmentInformation',
    fieldKeys: Object.values(USER_EMPLOYMENT_INFORMATION),
  },
];

export const groupUserFieldsByCategories = (
  userFields,
  categories = USER_FIELD_CATEGORIES
) => {
  return categories.map(category => {
    const fieldKeysSet = new Set(category.fieldKeys);

    return {
      ...category,
      fields: userFields.filter(field => fieldKeysSet.has(field.name)),
    };
  });
};

export const prepareInitialData = userFields => {
  return {
    informations: userFields,
  };
};

export const getFields = classes => [
  {
    name: 'informations',
    translationKey: 'infoFields',
    fieldWrapperClass: classes.informations,
    type: FIELD_TYPES.PEOPLE_INFO,
    required: true,
    fieldTypes: ORGANIZATION_SETTINGS_PEOPLE_INFO_FIELDS,
    isMultiple: true,
  },
];
